import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useParams } from "react-router-dom";

export const RequestUploadContext = createContext(null);

type Props = {
  children: ReactElement;
};

const RequestUploadProvider: FunctionComponent<Props> = ({ children }) => {
  const { id } = useParams();

  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post(
        `backoffice/onboarding/risk-profiles/${id}/document-upload-request`,
        payload,
      );
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const {
    mutateAsync: mutateAsyncRecheck,
    data: dataRecheck,
    isPending: dataRecheckIsPending,
    error: dataRecheckError,
  } = useMutation({
    mutationFn: async (payload: any) => {
      const data = await Api.post(
        `backoffice/onboarding/risk-profiles/${id}/documents/${payload.document_id}/recheck`,
        payload,
      );
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
      mutateAsyncRecheck,
      dataRecheck,
      dataRecheckIsPending,
      dataRecheckError,
    }),
    [
      mutateAsync,
      data,
      error,
      isPending,
      mutateAsyncRecheck,
      dataRecheck,
      dataRecheckIsPending,
      dataRecheckError,
    ],
  );
  return (
    <RequestUploadContext.Provider value={contextValue}>
      {children}
    </RequestUploadContext.Provider>
  );
};

export default RequestUploadProvider;
